export default __webpack_public_path__ + "static/media/Claridad Alta.42395b81.svg";